module.exports = __webpack_public_path__ + "static/img/no-class.28d90dea.png";